/* The Outdoor band prints Ghost's automatic excerpt, which stops after a
   fixed number of words - often in the middle of a sentence. Ghost has no
   helper that ends on a full stop, so this trims the text back to the last
   sentence that finishes. An excerpt that already ends cleanly is left
   alone, and so is one with no finished sentence in it, since a short
   fragment is worse than a long one. */
(function () {
    var nodes = document.querySelectorAll('.vb3-outdoor .vb3-review-lead-excerpt');
    if (!nodes.length) { return; }

    /* A full stop, question mark or exclamation mark (with any closing quote
       or bracket), then a space and the start of a new sentence. Needing a
       capital or digit next keeps "U.S. with" and "vs. the" from counting. */
    var ends = /[.!?]["'”’)\]]*(?=\s+["“‘(]?[A-Z0-9])/g;
    var clean = /[.!?]["'”’)\]]*$/;

    nodes.forEach(function (node) {
        var text = (node.textContent || '').trim();
        if (!text || clean.test(text)) { return; }

        var cut = -1;
        var m;
        ends.lastIndex = 0;
        while ((m = ends.exec(text)) !== null) { cut = m.index + m[0].length; }

        if (cut >= 40) { node.textContent = text.slice(0, cut); }
    });
})();
